<template>
  <div>
    <div v-if="loadingOverlay === true">{{loadingOverlayText}}</div>
    <div class="content">
      <div class="row" style="margin-left: 5px;">
        <p-button outline type="info" size="sm" round @click="$router.go(-1)">
          <i class="fa fa-chevron-circle-left"></i>
          Back
        </p-button>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="alert alert-danger alert-dismissible fade show" v-if="showAlert==true">
            <div v-for="alert in alertMsg" :key="alert">
              <button
                type="button"
                aria-hidden="true"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              >
                <i class="nc-icon nc-simple-remove"></i>
              </button>

              <span>{{alert}}</span>
            </div>
          </div>
          <div class="card">
            <div class="card-header" style="width: 100%">
              <h5 class="card-title" style="float:left;">Edit Campaign</h5>
            </div>
            <div class="card-body">
              <form ref="campaignForm">
                <div class="typography-line-custom">
                  <p>
                    <span>Select Client:</span>
                    <select
                      v-model="model.client"
                      v-validate="modelValidations.client"
                      name="client"
                      type="text"
                      id="client_input"
                      required
                      class="custom-select form-control"
                      :error="getError('client')"
                    >
                      <option value selected>select client</option>
                      <option
                        v-for="option in clientList"
                        :value="option.id"
                        :key="option.id"
                      >{{ option.name }}</option>
                    </select>
                  </p>
                </div>
                <div class="typography-line-custom">
                  <p>
                    <span style="margin-top:50px;">Campaign Name:</span>
                    <fg-input
                      placeholder="ex. BrandCo Influencer Campaign"
                      v-model="model.campaignName"
                      v-validate="modelValidations.campaignName"
                      name="campaignName"
                      id="campaignName_input"
                      type="text"
                      required
                    ></fg-input>
                  </p>
                </div>
                <div class="typography-line-custom">
                  <p>
                    <span>Campaign Description:</span>

                    <textarea
                      placeholder="ex. New campaign to promote the latest product release."
                      name="campaignDescription"
                      v-model="model.campaignDescription"
                      v-validate="'required'"
                      style="width:100%"
                      class="custom-textarea"
                      :error="getError('campaignDescription')"
                      type="text"
                      required
                    ></textarea>
                  </p>
                </div>
                <div class="typography-line-custom">
                  <p>
                    <span>Brand Description:</span>

                    <textarea
                      placeholder="ex. Brand Co. creates the best products ever."
                      name="brandDescription"
                      v-model="model.brandDescription"
                      v-validate="'required'"
                      style="width:100%"
                      class="custom-textarea"
                      :error="getError('brandDescription')"
                      type="text"
                      required
                    ></textarea>
                  </p>
                </div>
                <div class="typography-line-custom">
                  <div class="form-group">
                    <p>
                      <span>Campaign Start:</span>
                    </p>
                    <datepicker
                      v-model="campaignStart"
                      placeholder="Select Date:"
                      name="campaignStart"
                      input-class="calendar-input-custom"
                      format="M/d/yy"
                    ></datepicker>
                  </div>
                  <div>
                    <span>Campaign End:</span>
                  </div>
                  <div class="row" style="padding-left:10px; margin:0px; padding:0px;">
                    <div class="custom-radio-fieldset">
                      <input
                        type="radio"
                        id="ongoing"
                        value="ongoing"
                        v-model="endCampaignType"
                        @click="setCampaignEnd('ongoing')"
                      />
                      <label for="ongoing">Ongoing</label>
                      <br />
                    </div>

                    <div class="custom-radio-fieldset">
                      <input
                        type="radio"
                        id="end_date"
                        value="end_date"
                        v-model="endCampaignType"
                        @click="setCampaignEnd('end_date')"
                      />
                      <label for="end_date">End Date</label>
                    </div>
                  </div>
                  <div class="row" style="padding: 15px;">
                    <div v-if="showDate==true">
                      <datepicker
                        placeholder="Select Date:"
                        v-model="campaignEnd"
                        name="campaignEnd"
                        input-class="calendar-input-custom"
                        format="M/d/yy"
                      ></datepicker>
                    </div>
                  </div>
                </div>
                <div class="typography-line-custom">
                  <p>
                    <span style="margin-top:0px;">Landing Page:</span>
                    <fg-input
                      placeholder="eg. https://brandco.com/landingpage"
                      v-model="model.landingPage"
                    ></fg-input>
                  </p>
                </div>
                <div class="row">
                  <p-button color="success" class="mr-4" @click="onSubmit">SAVE Campaign</p-button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
import axios from "axios";
import VueCookies from "vue-cookies";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import {
  influencerCampaignCreateApi,
  clientListLoadApi
} from "@/config/appSettings";
export default {
  name: "AmbassadorCampaignCreate",
  components: {
    Datepicker
  },
  data: () => ({
    auth: null,
    email: null,
    alertMsg: null,
    showAlert: false,
    alertType: null,
    displayAlert: false,
    saveOverlay: null,
    brandDescription: null,
    campaignName: null,
    campaignDescription: null,
    campaignStart: null,
    campaignEnd: "ongoing",
    influencerDiscount: null,
    influencerDiscountType: null,
    influencerCommission: null,
    influencerCommissionType: null,
    followerDiscount: null,
    followerDiscountType: null,
    landingPage: null,
    trackingParams: null,
    clientList: null,
    client: null,
    showDate: false,
    endCampaignType: "ongoing",
    loadingOverlayText: null,
    loadingOverlay: false,
    model: {
      client: null,
      brandDescription: null,
      campaignName: null,
      campaignDescription: null,
      campaignStart: null,
      campaignEnd: "ongoing",
      influencerDiscount: null,
      influencerDiscountType: null,
      influencerCommission: null,
      influencerCommissionType: null,
      followerDiscount: null,
      followerDiscountType: null,
      landingPage: null,
      trackingParams: null
    },
    modelValidations: {
      brandDescription: {
        required: true
      },
      campaignName: {
        required: true
      },
      campaignDescription: {
        required: true
      },
      landingPage: {
        required: true
      }
    },

  
  }),
  created() {},
  mounted() {
    this.auth = firebase.auth().currentUser.uid;
    this.email = firebase.auth().currentUser.email;
    this.loadClientList();
  },
  methods: {
    getError(fieldName) {
      console.log("ERRORS FOUND: ", this.errors.first(fieldName));
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        try {
          console.log("CHECKING IS VALID:", isValid);
          console.log("CHECKING REGISTER FORM: ", this.registerForm);
          this.$emit("on-submit", this.registerForm, isValid);
        } catch (err) {
          console.log("THERE WAS AN ERROR:", err);
        }
      });
    },
    async onSubmit(e) {
      e.preventDefault();
      const self = this;
      self.saveOverlay = true;

      console.log("CHECKING VALIDATION:", await this.$validator.validateAll());
      let formErrors = [];

      if (
        this.model.campaignName == null ||
        this.model.campaignName.trim() == "" ||
        typeof this.model.campaignName == "undefined"
      ) {
        formErrors.push("Campaign Name Required");
      }
      if (
        this.model.campaignDescription == null ||
        this.model.campaignDescription.trim() == "" ||
        typeof this.model.campaignDescription == "undefined"
      ) {
        formErrors.push("Campaign Description Required");
      }
      if (
        this.model.brandDescription == null ||
        this.model.brandDescription.trim() == "" ||
        typeof this.model.brandDescription == "undefined"
      ) {
        formErrors.push("Brand Description Required");
      }
      if (
        this.model.client == null ||
        this.model.client.trim() == "" ||
        typeof this.model.client == "undefined"
      ) {
        formErrors.push("Client Required");
      }
      if (formErrors.length > 0) {
        this.showAlert = true;
        this.alertMsg = formErrors;
        window.scrollTo(0, 0);
        return;
      }

      if ((await this.$validator.validateAll()) === true) {
        let formInfo = {};
        formInfo.usertoken = this.auth;
        formInfo.brandDescription = self.model.brandDescription;
        formInfo.name = self.model.campaignName;
        formInfo.campaignDescription = self.model.campaignDescription;
        formInfo.startDate = self.campaignStart;
        formInfo.endDate = self.campaignEnd;
        formInfo.client = self.model.client;
        formInfo.landingPage = self.model.landingPage;
        try {
          if (self.trackingParams.trim().length > 0) {
            formInfo.trackingParams = self.trackingParams;
          }
        } catch (err) {}

        console.log("FORM INFO:", formInfo);

        let campaignResponse = await axios.post(
          influencerCampaignCreateApi,
          formInfo
        );
        console.log("HERE IS THE RESULT: ", campaignResponse.data);
        //console.log(  "HERE IS THE INFO FROM FIREBASE: ",firebase.auth().currentUser.uid );
        if (campaignResponse.data.success === true) {
          // FORWARD TO DETAIL PAGE
          this.$router.push(`/influencer-campaign/list/?new=true`);
        }
      } else {
        self.saveOverlay = false;
        self.alertMsg = "Please complete all fields.";
        self.alertType = "error";
        self.displayAlert = true;
        window.scrollTo(0, 0);
      }
    },
    async setCampaignEnd(event) {
      //console.log(event);

      if (event === "ongoing") {
        this.showDate = false;
        this.endCampaignType = "ongoing";
        this.campaignEnd = "ongoing";
        return;
      }
      if (event === "end_date") {
        this.showDate = true;
        this.campaignEnd = null;
        this.endCampaignType = "end_date";
        return;
      }
    },
    async campaignEndCheck(event) {
      if (this.endCampaignType === "end_date") {
        if (event === null || typeof event === "undefined") {
          return "Select campaign end date.";
        }
        if (moment(this.campaignEnd).isBefore(this.campaignStart)) {
          return "End date must be after start date";
        }
        return true;
      }
      if (this.endCampaignType === "ongoing") {
        this.campaignEnd = "ongoing";
      }
      return true;
    },
    async campaignStartCheck(event) {
      let today = moment().format("YYYY-MM-DD");
      //console.log("TODAYS DATE:", today);
      if (event === null || typeof event === "undefined") {
        return "Select campaign start date.";
      }
      if (moment(this.campaignStart).isBefore(today)) {
        return "Start date cannot be set before today.";
      }
      return true;
    },
    async loadClientList() {
      let clientRequest = await axios.get(
        `${clientListLoadApi}/?usertoken=${this.auth}&status=active`
      );
      console.log("CLIENT REQUEST:", clientRequest.data);
      let clientIdArray = clientRequest.data.result.map(x => {
        return { name: x.businessName, id: x._id };
      });
      console.log("HERE IS THE CLIENT ARRAY:", clientIdArray);
      if (clientIdArray.length > 0) {
        this.clientList = clientIdArray;
      }
    },

    toggleForm() {
      this.showForm = true;
      this.showIntro = false;
    }
  },
  created() {
    this.auth = firebase.auth().currentUser.uid;
    this.email = firebase.auth().currentUser.email;
    //this.loadCampaign();
    this.loadClientList();
  },
  mounted() {
    if (this.$route.query.new == "true") {
      this.alertMsg = "Campaign Created Successfully.";
      this.alertType = "success";
      this.displayAlert = true;
    }
  }
};
</script>

<style scoped>
.center-align {
  text-align: center;
}
.field-bg {
  background-color: white;
  margin: 10px;
}
</style>